export const genres = [
  'Pop',
  'Rock',
  'Electronic',
  'Hip-Hop / Rap',
  'R&B (Rhythm and Blues)',
  'Country',
  'Jazz',
  'Blues',
  'Folk',
  'Classical',
  'Reggae',
  'Funk',
  'Soul',
  'Punk',
  'Metal',
  'Indie',
  'Alternative',
  'Dance',
  'EDM (Electronic Dance Music)',
  'House',
  'Techno',
  'Trance',
  'Dubstep',
  'Gospel',
  'Latin',
  'Ska',
  'Bluegrass',
  'World Music',
  'Ambient',
  'Chillout',
  'New Age',
  'J-Pop (Japanese Pop)',
  'K-Pop (Korean Pop)',
  'Hardcore',
  'Experimental',
  'Acoustic',
  'Reggaeton',
  'Salsa',
  'Swing',
  'Fusion',
  'Psychedelic',
  'Grunge',
  'Gothic',
  'Emo',
  'Ska-Punk',
  'Post-Rock',
  'Post-Punk',
  'Neo-Soul',
  'Trap',
]
